module.exports = __webpack_public_path__ + "static/media/Test58.d880ce3b.bmp";